import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ums-feedback",
  "use": "icon-ums-feedback-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ums-feedback\"><path d=\"M128 224h768a64 64 0 0 1 64 64v544a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V288a64 64 0 0 1 64-64z m13.184 153.888l314.336 228.608a96 96 0 0 0 112.96 0l314.336-228.608a32 32 0 0 0-37.632-51.776l-314.368 228.64a32 32 0 0 1-37.632 0L178.816 326.08a32 32 0 0 0-37.632 51.776z\" fill=\"\" p-id=\"20561\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ums-feedback.svg
// module id = uhBA
// module chunks = 19